import { h } from 'preact';

export function IconEllipsis({ width = 15, height = 18, fill = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="icon-ellipsis"
    >
      <path
        d="M0.267578 8.57153C0.267578 8.07425 0.465122 7.59734 0.816753 7.24571C1.16838 6.89408 1.6453 6.69653 2.14258 6.69653C2.63986 6.69653 3.11677 6.89408 3.4684 7.24571C3.82003 7.59734 4.01758 8.07425 4.01758 8.57153C4.01758 9.06881 3.82003 9.54573 3.4684 9.89736C3.11677 10.249 2.63986 10.4465 2.14258 10.4465C1.6453 10.4465 1.16838 10.249 0.816753 9.89736C0.465122 9.54573 0.267578 9.06881 0.267578 8.57153ZM5.62472 8.57153C5.62472 8.07425 5.82227 7.59734 6.1739 7.24571C6.52553 6.89408 7.00244 6.69653 7.49972 6.69653C7.997 6.69653 8.47392 6.89408 8.82555 7.24571C9.17718 7.59734 9.37472 8.07425 9.37472 8.57153C9.37472 9.06881 9.17718 9.54573 8.82555 9.89736C8.47392 10.249 7.997 10.4465 7.49972 10.4465C7.00244 10.4465 6.52553 10.249 6.1739 9.89736C5.82227 9.54573 5.62472 9.06881 5.62472 8.57153ZM12.8569 6.69653C13.3541 6.69653 13.8311 6.89408 14.1827 7.24571C14.5343 7.59734 14.7319 8.07425 14.7319 8.57153C14.7319 9.06881 14.5343 9.54573 14.1827 9.89736C13.8311 10.249 13.3541 10.4465 12.8569 10.4465C12.3596 10.4465 11.8827 10.249 11.531 9.89736C11.1794 9.54573 10.9819 9.06881 10.9819 8.57153C10.9819 8.07425 11.1794 7.59734 11.531 7.24571C11.8827 6.89408 12.3596 6.69653 12.8569 6.69653Z"
        fill={fill}
      />
    </svg>
  );
}
